import cn from 'classnames';
import type { LegacyRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Card, ImageInputCropper } from '@shared/ui';
import * as st from './styles.module.scss';

export const Head = ({ fieldRef }: { fieldRef?: LegacyRef<HTMLFieldSetElement> }) => {
  const {
    watch,
    formState: { errors },
    control,
    setValue,
    clearErrors,
  } = useFormContext();

  const error = !!errors.title;
  const tileValue = watch('title');

  return (
    <fieldset className={st.fieldset} ref={fieldRef}>
      <Card className={st.title}>
        <div className={st.wrapper}>
          <div className={st.title__image}>
            <Controller
              control={control}
              name={`screenshot_url`}
              render={({ field: { value } }) => (
                <ImageInputCropper
                  aspect={[16, 9]}
                  iconVariant="cover"
                  value={value}
                  onChange={(value) => {
                    clearErrors('screenshot_url');
                    setValue(`screenshot_url`, value, { shouldDirty: true });
                  }}
                  isValid={!!errors.screenshot_url}
                />
              )}
            />
          </div>

          <div className={st.title__text_desktop}>
            {!tileValue && (
              <div className={st.placeholder}>
                <span className={cn(st.placeholder__text, error && st.error)}>Трейлер</span>
              </div>
            )}
          </div>
        </div>
      </Card>

      <div className={st.titleMobile}>
        <h3>Название</h3>

        <Card className={st.titleMobile__card}>
          <div className={st.titleMobile__field}>Трейлер</div>
        </Card>
      </div>
    </fieldset>
  );
};
